import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Eye, EyeOff, Loader2 } from 'lucide-react';
import { useAuth } from '../store/authStore';
import { loginAdmin } from '../api/auth';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const {
        token,
        user
      } = await loginAdmin(email, password);
      if (user.role !== 'admin') {
        setError('You do not have admin access. Please use a valid admin account.');
        return;
      }
      login(token, user);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Failed to sign in');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-background flex items-center justify-center p-4" data-id="element-759">
      <div className="w-full max-w-[400px] bg-surface border border-border rounded-card p-10" data-id="element-760">
        <div className="flex items-center gap-3 mb-2" data-id="element-761">
          <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center" data-id="element-762">
            <Heart className="w-5 h-5 text-white" data-id="element-763" />
          </div>
          <h1 className="text-[20px] font-semibold text-text-primary" data-id="element-764">
            Bella Admin
          </h1>
        </div>
        <p className="text-[14px] text-text-secondary mb-6" data-id="element-765">
          Sign in to continue
        </p>

        <div className="h-[1px] bg-border w-full mb-6" data-id="element-766" />

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-767">
          <div data-id="element-768">
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email address" className="w-full h-[44px] bg-background border border-border rounded-input px-4 text-text-primary placeholder:text-text-secondary focus:outline-none focus:border-accent transition-colors" required data-id="element-769" />
          </div>
          <div className="relative" data-id="element-770">
            <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" className="w-full h-[44px] bg-background border border-border rounded-input pl-4 pr-10 text-text-primary placeholder:text-text-secondary focus:outline-none focus:border-accent transition-colors" required data-id="element-771" />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary hover:text-text-primary transition-colors" data-id="element-772">
              {showPassword ? <EyeOff className="w-5 h-5" data-id="element-773" /> : <Eye className="w-5 h-5" data-id="element-774" />}
            </button>
          </div>

          <button type="submit" disabled={isLoading} className="w-full h-[44px] bg-accent text-background font-semibold rounded-btn flex items-center justify-center hover:opacity-90 transition-opacity disabled:opacity-50" data-id="element-775">
            {isLoading ? <Loader2 className="w-5 h-5 animate-spin" data-id="element-776" /> : 'Sign In'}
          </button>

          {error && <p className="text-danger text-sm text-center mt-2" data-id="element-777">{error}</p>}
        </form>
      </div>
    </div>;
}